// extracted by mini-css-extract-plugin
export default {"block":"OverlayBlockLoading_block__jp1JJ"};